import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" }
const _hoisted_2 = ["innerHTML"]

import { FloatButton } from 'ant-design-vue';
import { HttpStatusCode } from 'axios';
import { onMounted, ref, watch, capitalize } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Comic, ComicType } from '@/model/comic';
import { getComic, getComicChapter } from '@/repository/comic';
import { getDocumentDetail } from '@/repository/document';
import ImageLoading from '@/components/shared/ImageLoading.vue';
import ChapterControl from '@/components/disposable/ChapterControl.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComicView',
  props: {
    type: {}
  },
  setup(__props: any) {

const props = __props;

const { params } = useRoute();
const { push, replace } = useRouter();
const comicUUID = params.comicUUID as string;

const chapter = ref(params.chapter as string);
const isLoading = ref(true);
const comic = ref<Comic>();
const chapters = ref<string[]>([chapter.value]);
const imageURLs = ref<string[]>([]);
const content = ref<string>('');



onMounted(async () => {
	await fetchData();
	await fetchContent();
});

async function fetchData() {
	try {
		const res = await getComic(comicUUID);
		if (!res || res.status !== HttpStatusCode.Ok || !res.data) {
			throw Error('comic uuid is not found');
		}
		comic.value = res.data;
		chapters.value = Object.keys(comic.value.chapter).sort((a, b) => Number(a) - Number(b)) || [];
		document.title = `${res.data.title} Chapter ${chapter.value} - ${capitalize(props.type)} | Unikume Kinkando`;
	} catch (error) {
		push(`/${props.type}`);
	}
}

async function fetchContent() {
	if (!comic.value?.chapter[chapter.value]) {
		push(`/${props.type}`);
		return;
	}
	switch (props.type) {
		case ComicType.Novel: {
			isLoading.value = true;
			try {
				const { data } = await getComicChapter(comic.value?.comicUUID ?? '', chapter.value);
				content.value = data?.content ?? '';
				isLoading.value = false;
			} catch (error) {
				push(`/${props.type}`);
			}
			break;
		}

		default: {
			isLoading.value = true;
			imageURLs.value = [];
			await replace(`/${props.type}/${comicUUID}/${chapter.value}`);
			try {
				const document = await getDocumentDetail(
					comic.value?.chapter[chapter.value].documentUUID || '',
					true
				);
				if (document?.files) {
					imageURLs.value = document.files.map((file) => file.originalURL);
					isLoading.value = false;
				}
			} catch (error) {
				push(`/${props.type}`);
			}
			break;
		}
	}
}

watch(chapter, fetchContent);

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(FloatButton).BackTop),
    _createVNode(ChapterControl, {
      homeURL: `/${_ctx.type}/${comic.value?.comicUUID}`,
      "class-name": "mt-2 mb-2 sm:mb-4",
      chapter: chapter.value,
      chapters: chapters.value,
      onOnFetch: _cache[0] || (_cache[0] = (toChapter) => (chapter.value = toChapter))
    }, null, 8, ["homeURL", "chapter", "chapters"]),
    (isLoading.value)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(Array(10), (_, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "bg-gray-700 animate-pulse max-w-6xl w-full h-full aspect-square m-auto rounded-none"
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_a_spin, {
                tip: "Loading...",
                size: "large",
                class: "animate-pulse"
              })
            ])
          ]))
        }), 128))
      : (_ctx.type === _unref(ComicType).Novel)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "bg-white px-4 py-2 sm:px-10 sm:py-10 rounded-md text-start overflow-hidden",
            innerHTML: content.value
          }, null, 8, _hoisted_2))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(imageURLs.value, (imageURL, index) => {
            return (_openBlock(), _createBlock(ImageLoading, {
              key: index,
              src: imageURL,
              "img-class": "object-cover w-full h-full rounded-none",
              "loading-class": "max-w-6xl w-full h-full aspect-square m-auto rounded-none",
              "disabled-lazy-load": ""
            }, null, 8, ["src"]))
          }), 128)),
    _createVNode(ChapterControl, {
      homeURL: `/${_ctx.type}/${comic.value?.comicUUID}`,
      "class-name": "mt-2 sm:mt-4",
      chapter: chapter.value,
      chapters: chapters.value,
      onOnFetch: _cache[1] || (_cache[1] = (toChapter) => (chapter.value = toChapter))
    }, null, 8, ["homeURL", "chapter", "chapters"])
  ], 64))
}
}

})